import { ShaderChunk } from '../shaders/ShaderChunk';
import THREE from '../utils/threeClassesAdapter';
import { TexturesStorage } from '../init/TexturesStorage';
import { FlagMeshMatcapMaterial } from '../materials/FlagMeshMatcapMaterial';

const createMeshBasicMaterial = (config, type) => {
    const variantsConfig = {
        default: {
            color: 0xffffff,
            transparent: false,
            side: THREE.DoubleSide
        }
    };

    const { variant } = config || {};
    const defaults = variantsConfig[variant ?? type ?? 'default'];

    const params = { ...defaults, ...config };

    // Delete if have not yet
    delete params.type;

    const material = new THREE.MeshBasicMaterial(params);

    material.depthWrite = !params.transparent;

    return material;
};

const createDefaultMatcapMaterial = (config) => {
    const defaults = {
        color: 0xffffff,
        transparent: false,
        side: THREE.FrontSide
    };

    const params = { ...defaults, ...config };

    // Delete if have not yet
    delete params.type;

    return new THREE.MeshMatcapMaterial(params);
};

/* const createTextMaterial = (config) => {
    const { color, atlas, alphaTest } = config;

    return new THREE.RawShaderMaterial(
        MSDFShader({
            map: atlas,
            color: new THREE.Color(color ?? 0x000000),
            side: THREE.DoubleSide,
            transparent: false,
            alphaTest,
            negate: false
        })
    );
}; */

// Fog Support materials
const createTextMaterial2 = (config, variant, uniforms = {}) => {
    const { color, atlas, translate } = config;

    const fragmentShader = ShaderChunk.meshtext2_frag;
    const vertexShader = ShaderChunk.meshtext2_vert;

    return new THREE.ShaderMaterial({
        fragmentShader,
        vertexShader,
        side: THREE.DoubleSide,
        transparent: true,
        fog: true,
        uniforms: {
            uMap: new THREE.Uniform(atlas),
            uColor: new THREE.Uniform(new THREE.Color(color ?? 0x000000)),
            uTranslate: new THREE.Uniform(translate || new THREE.Vector3()),
            fogColor: { type: 'c', value: new THREE.Color(0x000000) },
            fogNear: { type: 'f', value: 50 },
            fogFar: { type: 'f', value: 80 },
            opacity: { type: 'f', value: 1 },
            ...uniforms
        }
    });
};

// Fog Support materials
// + circle bending
const createTextMaterial2Bent = (config, variant, uniforms = {}) => {
    const {
        color, atlas, translate, bendingRadius
    } = config;

    const fragmentShader = ShaderChunk.meshtext2_frag;
    const vertexShader = ShaderChunk.meshtext2bent_vert;

    return new THREE.ShaderMaterial({
        fragmentShader,
        vertexShader,
        side: THREE.DoubleSide,
        transparent: true,
        fog: true,
        uniforms: {
            uMap: new THREE.Uniform(atlas),
            uColor: new THREE.Uniform(new THREE.Color(color ?? 0x000000)),
            uTranslate: new THREE.Uniform(translate || new THREE.Vector3()),
            fogColor: { type: 'c', value: new THREE.Color(0x000000) },
            fogNear: { type: 'f', value: 50 },
            fogFar: { type: 'f', value: 80 },
            opacity: { type: 'f', value: 1 },
            bendingRadius: { type: 'f', value: (bendingRadius ?? 1) },
            ...uniforms
        }
    });
};

// Fog and Wave animation Support material
/* const createTextMaterial3 = (config, uniforms = {}) => {
    const { color, atlas } = config;

    return new THREE.ShaderMaterial({
        fragmentShader: ShaderChunk.meshtextwave_frag,
        vertexShader: ShaderChunk.meshtextwave_vert,
        side: THREE.DoubleSide,
        transparent: true,
        fog: true,
        uniforms: {
            uMap: new THREE.Uniform(atlas),
            uColor: new THREE.Uniform(new THREE.Color(color ?? 0x000000)),
            fogColor: { type: 'c', value: new THREE.Color(0x000000) },
            fogNear: { type: 'f', value: 50 },
            fogFar: { type: 'f', value: 80 },
            time: { type: 'f', value: 0 },
            ...uniforms
        }
    });
}; */

// Fog, Wave animation and Shift progress Support material
/* const createTextMaterial4 = (config, uniforms = {}) => {
    const { color, atlas } = config;

    return new THREE.ShaderMaterial({
        fragmentShader: ShaderChunk.meshtextwaveshift_frag,
        vertexShader: ShaderChunk.meshtextwaveshift_vert,
        side: THREE.DoubleSide,
        transparent: true,
        fog: true,
        uniforms: {
            uMap: new THREE.Uniform(atlas),
            uColor: new THREE.Uniform(new THREE.Color(color ?? 0x000000)),
            uShiftAmp: { type: 'f', value: 500 },
            uShiftInfluence: { type: 'f', value: 0 },
            fogColor: { type: 'c', value: new THREE.Color(0x000000) },
            fogNear: { type: 'f', value: 50 },
            fogFar: { type: 'f', value: 80 },
            time: { type: 'f', value: 0 },
            ...uniforms
        }
    });
}; */

const setTexture = async (material, textures, texturesTargetParam) => {
    if (textures instanceof Array) {

        material[texturesTargetParam ?? 'map'] = await TexturesStorage.getTexture(
            { options: textures }
        );
        material.needsUpdate = true;
    }
};

export const MaterialsFactory = {
    create(config, type) {
        // Default type is 'MeshBasicMaterial'
        // Add switch instructions to add options

        type = type ?? config.type;

        let material = null;

        config = { ...config };

        const { textures, texturesTargetParam } = config;

        if (textures instanceof Array) {
            delete config.textures;
            delete config.texturesTargetParam;
        }

        switch (type) {
            case 'textMaterial2':
                material = createTextMaterial2(config);

                break;
            case 'textMaterial2Bent':
                material = createTextMaterial2Bent(config);

                break;

            case 'matcap':
                material = createDefaultMatcapMaterial(config);

                break;

            case 'flagmatcap':
                material = new FlagMeshMatcapMaterial(config); console.log(material);

                break;

            default:
                material = createMeshBasicMaterial(config, type);

                break;
        }

        setTexture(material, textures, texturesTargetParam);

        return material;
    }
};
